import axios from '@utils/axios-client'

export async function fetchDataSearch (params: any = {}) {
  const response = axios.get('/api/v1/Store/Get', { params })
  return (await response).data
}

export async function getTopVote () {
  const response = axios.get('/api/v1/Ambassador/GetRankVote')
  return (await response).data
}
